<script setup lang="ts">
/** CaSeparator — garis pemisah, opsional dengan label di tengah. */
defineProps<{ label?: string }>()
</script>

<template>
  <USeparator
    :label="label"
    :ui="{
      border: 'border-line',
      label: 'text-muted ca-caption font-medium'
    }"
  />
</template>
